import styled from 'styled-components';

const Link = styled.a`
  text-decoration: none;
  color: ${props => props.theme.colors.black};
`;

export default Link;
